module.exports = __webpack_public_path__ + "static/img/banner-1.266abfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-1.png
// module id = /Y8n
// module chunks = 1